import 'whatwg-fetch'
import { getToken, logout } from 'utils/auth'
import store from 'store'

let { 
  API_URL
} = process.env 

if (!API_URL) throw new Error('Environment variable API_URL is not defined')

if (API_URL.endsWith('/')) {
  API_URL = API_URL.substring(0, API_URL.length-1)
}

API_URL = window.location.protocol +'//'+ API_URL

class APIClientBase {

  async GET(endpoint, data=null) {
    return await this.request('GET', endpoint, null, data)
  }

  async POST(endpoint, data=null) {
    return await this.request('POST', endpoint, data)
  }

  async PUT(endpoint, data=null) {
    return await this.request('PUT', endpoint, data)
  }

  async PATCH(endpoint, data=null) {
    return await this.request('PATCH', endpoint, data)
  }

  async DELETE(endpoint, data=null) {
    return await this.request('DELETE', endpoint, data)
  }

  async request(method, endpoint, body=null, query=null) {
    return new Promise(resolve => {
      let headers = {}
      const token = getToken()
      if (token) {
        headers.Authorization = 'Bearer ' + token
      }
      let q = ''
      if (query) {
        q = '?' + Object.keys(query).map(field => `${field}=${query[field]}`).join('&')
      }
      const bodyHolder = {}
      if (body) {
        bodyHolder.body = JSON.stringify(body)
      }
      fetch(API_URL + '/api' + endpoint + q, {
        method: method,
        //cache: "force-cache",
        headers: {
          'Content-Type': 'application/json',
          ...headers
        },
        ...bodyHolder,
      })
      .then(async (res) => {
        let response = null
        try {
          response = await res.json()

          if (response && response.error) {
            if ([
                "token_expired", 
                "token_not_provided", 
                "token_invalid", 
                "invalid_token"
              ].includes(response.error)) {
              logout()
              window.location.href = '/login'
            }
          }
        } 
        catch (e) {

        }
        finally {
          if (res.status == 500) {
            return store.dispatch({ type: 'SHOW_ERROR', payload: 'Something went wrong' })
          }
          if (res.status == 400 && typeof response === 'object' && Object.keys(response).length == 0) {
            response = null
          }
          resolve({
            status: res.status,
            response
          })
        }
      })
      /*.catch(async (res) => {
        return store.dispatch({ type: 'SHOW_ERROR', payload: 'Something went wrong' })
        /*resolve({
          status: 500,
          response: res
        })
      })*/
    })
  }

}

const APIClient = new APIClientBase()

export default APIClient



// WEBPACK FOOTER //
// ./src/api/APIClient.js